import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  mssentinelAlert: {},
  mssentinelEmailAlertToClient: {},
  alertLogDescription: {},
  alertLog: {},
  updateMSSentinelAlert: {},
  isLoading: false,
  error: null,
};

const mssentinelSlice = createSlice({
  name: 'mssentinel',
  initialState,
  reducers: {
    start: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    setReducerError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    setMSSentinelAlert: (state, action) => {
      state.mssentinelAlert = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setMSSentinelEmailAlertToClient: (state, action) => {
      state.mssentinelEmailAlertToClient = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setUpdateMSSentinelAlert: (state, action) => {
      state.updateMSSentinelAlert = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setMSSentinelAlertLogDescription: (state, action) => {
      state.alertLogDescription = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setMSSentinelAlertLog: (state, action) => {
      state.alertLog = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setResetMsSentinel: () => {
      return initialState;
    },
  },
});

export const {
  start,
  setReducerError,
  setMSSentinelAlert,
  setMSSentinelEmailAlertToClient,
  setUpdateMSSentinelAlert,
  setMSSentinelAlertLogDescription,
  setMSSentinelAlertLog,
  setResetMsSentinel,
} = mssentinelSlice.actions;

export default mssentinelSlice.reducer;
